module.exports = __webpack_public_path__ + "img/Z61Q_14.f090a7b6.jpg";